import { render, staticRenderFns } from "./QueryPolicyBondRisk.vue?vue&type=template&id=a929af72&"
import script from "./QueryPolicyBondRisk.vue?vue&type=script&lang=js&"
export * from "./QueryPolicyBondRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports